import { render, staticRenderFns } from "./VineyardFertilizerMetricTable.vue?vue&type=template&id=16b05ef6&scoped=true&"
import script from "./VineyardFertilizerMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardFertilizerMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b05ef6",
  null
  
)

export default component.exports